export const CORE_CHECKOUT_NAME = "core-checkout";

export enum CoreCheckoutComponent {
  CheckoutPage = "CheckoutPage",
  ContactInformationForm = "ContactInformationForm",
  ConfirmationPageHeader = "ConfirmationPageHeader",
  ContactInformationReview = "ContactInformationReview",
  CheckoutTitleSection = "CheckoutTitleSection",
  PassengerReview = "PassengerReview",
  PassengerSelection = "PassengerSelection",
  GuestSelection = "GuestSelection",
}
